var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CrudList',{attrs:{"title":"Terminos y Condiciones","storeName":"Terms","labelAddNew":"Agregar","sortable":"","canSearch":"","next-link":"/admin/dashboard","breadcrumbs":[
    {
      text: 'Configuración y politicas',
      disabled: false,
      href: '/admin/terms'
    },
    {
      text: 'Terminos y Condiciones',
      disabled: false,
      href: '#'
    }
  ]},scopedSlots:_vm._u([{key:"description",fn:function({ item }){return [_c('v-container',{staticClass:"overflow-y-auto",staticStyle:{"max-height":"210px"},attrs:{"id":"scroll-target"}},[_c('v-row',{directives:[{name:"scroll",rawName:"v-scroll:#scroll-target",value:(_vm.onScroll),expression:"onScroll",arg:"#scroll-target"}]},[_c('p',[_vm._v(" "+_vm._s(item.description))])])],1)]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }